<template>
  <naj-box :title="sectionTitle">
    <v-row>
      <v-col
        cols="12"
        lg="3"
      >
        <naj-input
          v-if="partyTypeOptions && partyTypeOptions.length > 0"
          :type-id="formFieldType.selectbox"
          :label="local.partyTypeSelection.type"
          :value.sync="formModel.partyType"
          :items="partyTypeOptions"
          item-text="name"
          item-value="id"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        v-if="isPerson(formModel)"
        cols="3"
        class="my-auto"
      >
        <naj-input
          :type-id="formFieldType.radioButton"
          :value.sync="formModel.isInheritor"
          :label="local.partyTypeSelection.isInheritor1"
          :items="yesOrNo.map(c=> ({...c,id:Boolean(c.id)}))"
          item-value="id"
          item-text="name"
          validates="required"
        ></naj-input>
      </v-col>
      <v-col
        v-if="isOfType(formModel,'person') && !isInheritor(formModel)"
        cols="6"
        lg="3"
        class="my-auto"
      >
        <naj-input
          :type-id="formFieldType.checkbox"
          :label="local.partyTypeSelection.isOrganizationOwner"
          :value.sync="formModel.isOrganizationOwner"
        ></naj-input>
      </v-col>
    </v-row>
  </naj-box>
</template>

<script>
import { isInheritor, isPerson, isOfType } from '../../helpers/utils';
import { createNamespacedHelpers } from 'vuex';

const { mapState: mapLUTState, mapActions: mapLUTActions } = createNamespacedHelpers('LookupsModule');
export default {
  inject: ['$validator'],
  props: ['formModel', 'sectionTitle','partyTypesList' // this prop is added to pass the party types list from active party attributes if available
  ],
  data() {
    return {
      isPerson,
      isInheritor,
      isOfType,
    };
  },
  computed: {
    ...mapLUTState(['partyTypes', 'yesOrNo']),
    partyTypeOptions() {
      return (this.partyTypesList && this.partyTypesList.length > 0)
        ? this.partyTypesList
        : this.partyTypes;
    },
    partyTypeId() {
      return this.formModel.partyType;
    },
  },
  watch: {
    partyTypeId() {
      this.clearObject(this.formModel, [
        'objectKey',
        'casePartyObjectKey',
        'partyType',
        'casePartyRole',
        'subPartyRoleId',
      ]);
    },
    'formModel.isOrganizationOwner'() {
      this.clearObject(this.formModel, [
        'isOrganizationOwner',
        'objectKey',
        'casePartyObjectKey',
        'partyType',
        'casePartyRole',
      ]);
    },
    'formModel.isInheritor'(val) {
      if (!val)
        this.$set(this.formModel, 'isInheritor', false);
    },
  },
  created() {
    this.getPartyTypes();
  },
  methods: {
    ...mapLUTActions(['getPartyTypes']),
    clearObject(state, exceptArr) {
      for (const key in state) {
        if (Object.prototype.hasOwnProperty.call(state, key) && exceptArr.indexOf(key) === -1) {
          if (typeof state[key] === 'object') {
            this.clearObject(state[key], exceptArr);
          } else {
            state[key] = undefined;
          }
        }
      }
    },
  },
};
</script>
